import { gql } from 'apollo-angular';

export var nav_search_ein = gql`
  query navSearchEIN($ein: String!) {
    get_project_by_ein(ein: $ein) {
      id
      name
    }
    get_fund_by_ein(ein: $ein) {
      id
      name
    }
  }
`;
